module.exports = __webpack_public_path__ + "src/assets/img/pointer.08b6fd5d.svg";